export default __webpack_public_path__ + "static/media/info.ee069274.png";